import { RootState } from 'store';

// creators list
export const creatorsSelector = (state: RootState) => state.creators.creators;
export const creatorsPendingSelector = (state: RootState) => state.creators.pending.creators;
export const creatorsErrorSelector = (state: RootState) => state.creators.errors.creators;
// profile
export const creatorProfileSelector = (state: RootState) => state.creators.profile;
export const creatorProfilePendingSelector = (state: RootState) => state.creators.pending.profile;
export const creatorProfileErrorSelector = (state: RootState) => state.creators.errors.profile;
// profile rolls
export const creatorProfileRollSelector = (state: RootState) => state.creators.profileRoll;
export const creatorProfileRollPageSelector = (state: RootState) => state.creators.page;
export const creatorProfileRollPendingSelector = (state: RootState) => state.creators.pending.profileRoll;
export const creatorProfileRollErrorSelector = (state: RootState) => state.creators.errors.profileRoll;
export const creatorProfileRollAssetsSelector = (state: RootState) => state.creators.rollAssets;
export const creatorProfileRollPreviewsSelector = (state: RootState) => state.creators.rollPreviews || [];
export const creatorProfileRollPreviewsAssetsSelector = (state: RootState) => state.creators.rollPreviewsAssets;
export const creatorProfileRollIsMoreSelector = (state: RootState) => state.creators.isMoreRolls;

// report roll
export const creatorRollReportErrorSelector = (state: RootState) => state.creators.errors.reportRoll;
export const creatorRollReportPendingSelector = (state: RootState) => state.creators.pending.reportRoll;
